import { ClientProviderStateObservables } from '#/models/ClientProvider.interface';

export const mapUserObservables = (observables: ClientProviderStateObservables) => ({
  ACLACSDocument: JSON.parse(observables.ACLACSDocument),
  ACLAIDocument: JSON.parse(observables.ACLAIDocument),
  ACLAccount: JSON.parse(observables.ACLAccount),
  ACLBPDocument: JSON.parse(observables.ACLBPDocument),
  ACLIPSDocument: JSON.parse(observables.ACLIPSDocument),
  ACLTaxDocument: JSON.parse(observables.ACLTaxDocument),
  ACLYESDocument: JSON.parse(observables.ACLYESDocument),
  hasACSDocuments: JSON.parse(observables.hasACSDocuments),
  hasBillPayDocuments: JSON.parse(observables.hasBillPayDocuments),
  hasIPSDocuments: JSON.parse(observables.hasIPSDocuments),
  hasMobileCheckDeposit: JSON.parse(observables.hasMobileCheckDeposit),
  hasYESDocuments: JSON.parse(observables.hasYESDocuments),
  terms_conditions_flag: observables.terms_conditions_flag,
  hasConsolidatedReporting: observables.hasConsolidatedReporting,
});
